import React from "react";
import { ClockCircleOutlined } from "@ant-design/icons";
import { Tag, Tooltip } from "antd";
const PendingTag = ({ bold }) => (React.createElement(Tooltip, { color: "white", title: "This item is currently pending and requires further action." },
    React.createElement(Tag, { icon: React.createElement(ClockCircleOutlined, null), color: "gold", style: { fontWeight: bold ? "bold" : "normal" } }, "Pending")));
PendingTag.defaultProps = {
    bold: false,
};
export default PendingTag;
